import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-lg-8 offset-lg-2" }
const _hoisted_3 = { class: "card card-flush" }
const _hoisted_4 = { class: "card-header pt-7" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left fs-2 pe-4 p-1" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "card-label fw-bolder fs-1" }
const _hoisted_9 = {
  key: 0,
  class: "fw-bold fs-6"
}
const _hoisted_10 = { class: "card-toolbar" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-inline" }, "for now", -1)
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "d-flex align-items-center w-100 mb-8" }
const _hoisted_15 = { class: "progress h-8px w-100 me-2 bg-light-primary" }
const _hoisted_16 = ["aria-valuenow"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "d-flex align-items-center flex-grow-1 me-2 me-sm-5" }
const _hoisted_19 = { class: "me-2" }
const _hoisted_20 = { class: "text-white fs-4 fw-bolder" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "fw-normal d-none d-md-inline" }, "has invited you to join their production on StageHub", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "fw-normal d-inline d-md-none" }, "sent you an invitation.", -1)
const _hoisted_23 = { class: "fw-bolder d-block fs-7 d-none" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = { class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6" }
const _hoisted_26 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-secondary\"><i class=\"fa fa-photo fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Upload Profile Photo</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">make yourself more visible on StageHub</span></div></div>", 1)
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-secondary\"><i class=\"fa fa-badge-check fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Verify Your Phone Number</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">verify your number to be able to receive alerts from stage managers</span></div></div>", 1)
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-circle-envelope fa-3x text-success" }, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-secondary\"><i class=\"fa fa-phone-plus fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Add a Phone Number</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">add a phone that can receive texts, to get alerts from stage managers</span></div></div>", 1)
const _hoisted_39 = { class: "d-flex align-items-center" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-secondary\"><i class=\"fa fa-badge-check fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Verify Your Email</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">verify your email to be able to receive alerts from stage managers</span></div></div>", 1)
const _hoisted_42 = { class: "d-flex align-items-center" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-secondary\"><i class=\"fa fa-kit-medical fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Add Emergency Contacts</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">only stage managers of shows you are actively a member of can see your emergency contacts</span></div></div>", 1)
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_50 = { key: 1 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-secondary\"><i class=\"fa fa-shirt-long-sleeve fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Add Measurements</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">only stage managers of shows you are actively a member of can see this</span></div></div>", 1)
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_56 = { key: 1 }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center flex-grow-1 me-2 me-sm-5\"><div class=\"symbol symbol-50px me-4 d-none d-md-inline\"><span class=\"symbol-label bg-secondary\"><i class=\"fa fa-chart-network fa-2x text-white\"></i></span></div><div class=\"me-2\"><div class=\"text-white fs-4 fw-bolder\">Join a production</div><span class=\"d-none d-md-inline fw-bolder d-block fs-7\">request access to an organization or production</span></div></div>", 1)
const _hoisted_60 = { class: "d-flex align-items-center" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-right" }, null, -1)
const _hoisted_62 = { key: 1 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-circle fa-3x text-success" }, null, -1)
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_66 = { class: "m-auto" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-party-horn text-primary fa-4x" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 text-white text-hover-white" }, "Return To Main Screen", -1)
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 text-primary text-hover-white" }, "Go To Profile", -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 text-white text-hover-white" }, "Go To Profile", -1)
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = { class: "d-flex flex-column align-items-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_UserEmergencyContactsCard = _resolveComponent("UserEmergencyContactsCard")!
  const _component_MeasurementSettings = _resolveComponent("MeasurementSettings")!
  const _component_PhoneNumberModal = _resolveComponent("PhoneNumberModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.subStep !== 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "d-block d-md-none cursor-pointer",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToChecklist && _ctx.backToChecklist(...args)))
              }, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.headerTitle), 1),
            (_ctx.subStep === 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Let's get you set up"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.subStep === 0 && !_ctx.completed)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "secondary",
                  onClick: _ctx.skip,
                  class: "d-none d-md-block"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Skip "),
                    _hoisted_11
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.subStep !== 0)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "d-none d-md-block btn-sm",
                  type: "secondary",
                  onClick: _ctx.backToChecklist
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("go back ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.subStep === 1)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  class: "d-none d-md-block btn-sm ms-4",
                  type: "primary",
                  onClick: _ctx.addContact
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("add contact ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.subStep === 0 && !_ctx.completed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", {
                      class: "progress-bar bg-primary",
                      role: "progressbar",
                      style: _normalizeStyle(`width: ${_ctx.progress}%`),
                      "aria-valuenow": _ctx.progress,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, null, 12, _hoisted_16)
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userStore.incomingInvitations, (invitation) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "d-flex border border-primary border-dashed rounded p-6 mb-6 cursor-pointer",
                    key: invitation.entityName,
                    onClick: ($event: any) => (_ctx.viewInvitation(invitation))
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createTextVNode(_toDisplayString(invitation.entityName) + " ", 1),
                          _hoisted_21,
                          _hoisted_22
                        ]),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(invitation.title), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_Button, {
                          type: "primary",
                          class: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" View ")
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ], 8, _hoisted_17))
                }), 128)),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
                    (_ctx.userStore.profile.avatar === '' || _ctx.userStore.profile.avatar === null)
                      ? _withDirectives((_openBlock(), _createBlock(_component_el_upload, {
                          key: 0,
                          class: "avatar-uploader",
                          "show-file-list": false,
                          "on-success": _ctx.handleAvatarSuccess,
                          "before-upload": _ctx.beforeAvatarUpload,
                          "http-request": _ctx.requestCropper
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Button, {
                              type: "primary",
                              class: "btn-icon btn-sm"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["on-success", "before-upload", "http-request"])), [
                          [_directive_loading, _ctx.photoIsLoading]
                        ])
                      : (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                  ])), [
                    [_directive_loading, _ctx.photoIsLoading]
                  ])
                ]),
                (_ctx.hasUnverified)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.verifyPhone && _ctx.verifyPhone(...args)))
                    }, [
                      _hoisted_32,
                      _createElementVNode("div", _hoisted_33, [
                        (_ctx.hasUnverified)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              type: "primary",
                              class: "btn-icon btn-sm"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_34
                              ]),
                              _: 1
                            }))
                          : (_ctx.hasVerified)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
                            : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.hasNoPhone)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addPhone && _ctx.addPhone(...args)))
                    }, [
                      _hoisted_38,
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_Button, {
                            type: "primary",
                            class: "btn-icon btn-sm"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_40
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.verifyEmail && _ctx.verifyEmail(...args)))
                }, [
                  _hoisted_41,
                  _createElementVNode("div", _hoisted_42, [
                    (_ctx.hasUnverifiedEmail)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          type: "primary",
                          class: "btn-icon btn-sm"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_43
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_44, _hoisted_46))
                  ])
                ]),
                _createElementVNode("div", {
                  class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.subStep = 1))
                }, [
                  _hoisted_47,
                  _createElementVNode("div", _hoisted_48, [
                    (_ctx.emergencyContacts.length === 0)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          type: "primary",
                          class: "btn-icon btn-sm",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.subStep = 1))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_49
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
                  ])
                ]),
                _createElementVNode("div", {
                  class: "d-none d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.subStep = 2))
                }, [
                  _hoisted_53,
                  _createElementVNode("div", _hoisted_54, [
                    (!_ctx.measurementsComplete)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          type: "primary",
                          class: "btn-icon btn-sm",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.subStep = 2))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_55
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_58))
                  ])
                ]),
                _createElementVNode("div", {
                  class: "d-flex border border-gray-300 border-dashed rounded p-6 mb-6 cursor-pointer",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.requestAccess && _ctx.requestAccess(...args)))
                }, [
                  _hoisted_59,
                  _createElementVNode("div", _hoisted_60, [
                    (!_ctx.hasMemberships)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 0,
                          type: "primary",
                          class: "btn-icon btn-sm"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_61
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.subStep === 0 && _ctx.completed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createVNode(_component_el_empty, { description: "Nice! You've finished setting up your StageHub profile." }, {
                    image: _withCtx(() => [
                      _hoisted_67
                    ]),
                    default: _withCtx(() => [
                      (_ctx.isFromFlow)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "btn btn-primary d-flex flex-column flex-center mt-4",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.keepGoing && _ctx.keepGoing(...args)))
                          }, _hoisted_69))
                        : _createCommentVNode("", true),
                      (_ctx.isFromFlow)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "btn-link btn link-primary text-primary d-flex flex-column flex-center",
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.finish && _ctx.finish(...args)))
                          }, _hoisted_71))
                        : _createCommentVNode("", true),
                      (!_ctx.isFromFlow)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "btn btn-primary text-primary d-flex flex-column flex-center",
                            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.navigateToUserHome && _ctx.navigateToUserHome(...args)))
                          }, _hoisted_73))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.subStep === 1)
            ? (_openBlock(), _createBlock(_component_UserEmergencyContactsCard, { key: 2 }))
            : _createCommentVNode("", true),
          (_ctx.subStep === 2)
            ? (_openBlock(), _createBlock(_component_MeasurementSettings, { key: 3 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_74, [
            (_ctx.subStep === 0 && !_ctx.completed)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "d-block d-md-none mb-4",
                  type: "secondary",
                  onClick: _ctx.skip
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Skip for now ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_PhoneNumberModal, {
      ref: "phoneNumberModal",
      onAdded: _ctx.refetchProfile,
      onVerified: _ctx.refetchProfile
    }, null, 8, ["onAdded", "onVerified"])
  ]))
}